import { Reveal } from "./Reveal";

export const PageHeader = ({ eyebrow, title, subtitle, image }) => (
  <section data-testid="page-header" className="relative pt-40 pb-20 lg:pt-52 lg:pb-28 overflow-hidden bg-dst-ink grain">
    {image && (
      <>
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(${image})` }} />
        <div className="absolute inset-0 bg-gradient-to-t from-dst-ink via-dst-ink/80 to-dst-ink/50" />
      </>
    )}
    <div className="container-dst relative z-10">
      <Reveal>
        <span className="eyebrow text-dst-red">{eyebrow}</span>
      </Reveal>
      <Reveal delay={0.1}>
        <h1 className="mt-5 font-oswald font-700 uppercase tracking-tighter leading-[0.85] text-6xl sm:text-7xl lg:text-8xl">
          {title}
        </h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.2}>
          <p className="mt-6 text-white/70 text-lg max-w-2xl">{subtitle}</p>
        </Reveal>
      )}
    </div>
  </section>
);
